import { useNoteNames } from "../../Project/ProjectStore"

export class Music{
    static majorScaleIntervals:number[] = [2,2,1,2,2,2,1]
    static majorScalePositions:number[] = [0,2,4,5,7,9,11]
    static notesSharp:string[] = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B']
    static notesFlat:string[] = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B']
    static notesHawaiian:string[] = ['I', 'Ke', 'La', 'Mu', 'Nu', 'O', 'Pi', 'U', 'We', 'A', 'E', 'He']
    static noteLabels:string[][] = [Music.notesSharp, Music.notesFlat, Music.notesHawaiian]
    static notes:string[] = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B']
    static C:number   = 0
    static Db:number  = 1
    static D:number   = 2
    static Eb:number  = 3
    static E:number   = 4
    static F:number   = 5
    static Gb:number  = 6
    static G:number   = 7
    static Ab:number  = 8
    static A:number   = 9
    static Bb:number  = 10
    static B:number   = 11
    static NoteTonics:number[] = [0,1,2,3,4,5,6,7,8,9,10,11]
    static getAllTonicsStartingAt = function(tonic:number, repeatRoot?:boolean){
      const tonics:number[] = Music.NoteTonics.concat()
      const index:number = Music.NoteTonics.indexOf(tonic)
      const front:number[] = tonics.splice(0,index)
      console.log('front', front)
      console.log('tonics after splice', tonics)
      let sequence:number[] = tonics.concat(front)
      console.log('sequence', sequence)
      if(repeatRoot){
        sequence.push(sequence[0])
      }
      return sequence
    }
    static flat:number = 1
    static sharp:number = 0
    static hawaiian:number = 2

    static addInterval = function(note:number, interval:number){
      return((note + interval + 12) % 12 )
    }

    static IntervalNames:string[] = ['1st', 'b2nd', '2nd', 'b3rd', '3rd', '4th', 'b5th', '5th', 'b6th', '6th', 'b7th', '7th', 'Octave' ]
    static interval_2nd:number = 2
    static interval_minor3rd:number = 3
    static interval_3rd:number = 4
    static interval_4th:number = 5
    static interval_sharp4th:number = 6
    static interval_5th:number = 7
    static interval_flat6th:number = 8
    static interval_6th:number = 9
    static interval_flat7th:number = 10
    static interval_7th:number = 11
    static interval_8th:number = 0
    static getIntervalTo = (position:number) => {
      if(position === 0 || position === 3){
        return(1)
      }
      return(2)
    }
    static getKeyScale = (tonic:number, repeatRoot:boolean = false)=>{
      let scale:number[] = [tonic]
      let currentNote:number = tonic
      for(let i:number = 0; i < 6; i++){
        currentNote = (currentNote + Music.majorScaleIntervals[i]) % 12
        scale.push(currentNote)
      }
      if(repeatRoot){
        scale.push(scale[0])
      }
      return scale
    }
    static getPentatonicScale = (tonic:number, repeatRoot?:boolean) => {
      const scale:number[] = Music.getKeyScale(tonic)
      scale.splice(3,1)
      scale.splice(5,1)
      return scale
    }
    static getPentatonicMode = (tonic:number, modeIndex:number, repeatRoot?:boolean) => {
        const ogPent:number[] = Music.getPentatonicScale(tonic, true)
        const start:number[] = ogPent.splice(0,modeIndex)
        const scale:number[] = ogPent.concat(start)
        return scale
    }
    static getBluesScale = (tonic:number, repeatRoot?:boolean) => {
      const scale:number[] = Music.getKeyScale(tonic)
      scale.splice(3,1)
      scale.splice(5,1)
      const blueNote:number = (tonic + 3) % 12
      scale.splice(2, 0, blueNote)
      return scale
    }
    static getMinorBluesScale = (tonic:number, modeIndex:number) => {
        const ogPent:number[] = Music.getBluesScale((tonic + 3) % 12)
        const start:number[] = ogPent.splice(0, 5)
        const scale:number[] = ogPent.concat(start)
        return scale
    }
} 
export function useScaleNotes(tonic:number, repeatRoot?:boolean){
  const noteNames:string[] = useNoteNames()
  const scale:number[] = Music.getKeyScale(tonic)
  if(repeatRoot){
    scale.push(scale[0])
  }
  const notes:string[] = scale.map((noteTonic:number)=>{
      return noteNames[noteTonic]
  })
  return notes
}
export function usePentatonicScaleNotes(tonic:number, modeIndex:number, repeatRoot?:boolean){
  const noteNames:string[] = useNoteNames()
  const scale:number[] = Music.getPentatonicMode(tonic, modeIndex, repeatRoot)
  if(repeatRoot){
    scale.push(scale[0])
  }
  const notes:string[] = scale.map((noteTonic:number)=>{
      return noteNames[noteTonic]
  })
  return notes
}

    